export const data = {
  title: 'Mylo Care Stretch Marks Relief Kit',
  description:
    'Clinically proven to have helped 9 out of 10 women in significantly reducing their stretch marks!',
  featureText:
    'Based on a study done by an NABL Accredited Lab on 100 Post Delivery Woman Over 84 Days.',
  features: [
    'Fades Old Stretch Marks',
    'Prevents New Stretch Marks',
    'Soothes Itchy Skin',
    'Nourishes & moisturizes skin',
  ],
  buttonCTA: 'Buy Now',
  deeplink: '/product/stretch-marks-day-night-kit-oil-100-ml-cream-100-gm-979',
  bannerImg:
    'https://images.myloapp.in/NestJsUploads/1684920319701-Group-319286@3x.webp',
  products: [
    {
      webUrl:
        '/product/stretch-marks-cream-with-saffron-shea-butter-kokum-100-gm-280',
      imgUrl:
        'https://images.myloapp.in/NestJsUploads/1684920319702-Image-59@3x.webp',
      name: 'Stretch Marks Cream',
      id: 280,
    },
    {
      webUrl:
        '/product/stretch-marks-oil-with-sea-buckthorn-oil-rosehip-oil-argan-oil-100-ml-847',
      imgUrl:
        'https://images.myloapp.in/NestJsUploads/1684920319704-Image-60@3x.webp',
      name: 'Stretch Marks Oil',
      id: 847,
    },
  ],
  detailHeading: "What's included in the kit?",
  bannerId: 979,
  bannerName:
    'Mylo Stretch Marks- Day & Night Kit - Oil (100 ml) & Cream (100 gm)',
};
export const oneTouchFold = {
  heading: 'One-Touch Fold',
  subPoints: [
    {
      heading: 'Master of Tight Spaces',
      description:
        'Folds into a compact unit to carry in your car’s boot or store in a small cabinet at home',
    },
    {
      heading: 'Travel Ready',
      description:
        'Fits in air-plane cabin storage. Luggage bar to stroll in folded position',
    },
  ],
  banner_image:
    'https://images.myloapp.in/NestJsUploads/1695128000477-Stroller-Listing-1.mp4',
  banner_type: 'VIDEO',
  showBuyNow: false,
};

export const superiorSafety = {
  heading: 'Superior Safety Standards',
  subPoints: [
    {
      description:
        'Designed to keep your precious cargo snug and safe, Mylo Baby Stroller, is EN-1888 certified, adhering to the stringent European safety standards. ',
    },
    {
      description:
        'Every ride is secure with a 5-point safety seatbelt. Plus, the rear wheel brakes ensure a safe halt when you need it.',
    },
  ],
  banner_image:
    'https://images.myloapp.in/NestJsUploads/1695128000478-Stroller-Listing-2.mp4',
  banner_type: 'VIDEO',
  showBuyNow: false,
};

export const readyForAdventureGrey = {
  heading: 'Smart, Feature-Loaded and Ready for Adventure',
  subPoints: [
    {
      description:
        'Crafted with the modern parent in mind, the Mylo Stroller comes packed with smart features',
    },
  ],
  categories: [
    {
      category_name: 'Multi level Recline',
      category_image:
        'https://images.myloapp.in/NestJsUploads/1690866360168-Recline-&-Footrest.webp',
    },
    {
      category_name: 'Foldable Sunshade',
      category_image:
        'https://images.myloapp.in/NestJsUploads/1690866360166-Foldable-Sunshade.webp',
    },
    {
      category_name: 'Bottle Holder',
      category_image:
        'https://images.myloapp.in/NestJsUploads/1694091937703-features-section_bottle-holder.webp',
    },
    {
      category_name: 'Generous Storage',
      category_image:
        'https://images.myloapp.in/NestJsUploads/1690866360168-GenerousStorage.webp',
    },
    {
      category_name: 'Peek-a-boo Mesh Window',
      category_image:
        'https://images.myloapp.in/NestJsUploads/1690866360168-Peek-a-boo-Mesh-Window.webp',
    },
    {
      category_name: 'Swivel Wheels With Lock',
      category_image:
        'https://images.myloapp.in/NestJsUploads/1694091901314-features-section_swivel-wheels.webp',
    },
  ],
  banner_image:
    'https://images.myloapp.in/NestJsUploads/1695128000468-Stroller-Listing-3.mp4',
  banner_type: 'VIDEO',
  showBuyNow: false,
  showParition: false,
};
export const readyForAdventure = {
  heading: 'Smart, Feature-Loaded and Ready for Adventure',
  subPoints: [
    {
      description:
        'Crafted with the modern parent in mind, the Mylo Stroller comes packed with smart features',
    },
  ],
  categories: [
    {
      category_name: 'Multi level Recline',
      category_image:
        'https://images.myloapp.in/NestJsUploads/1690866572317-Recline-&-Footrest.webp',
    },
    {
      category_name: 'Foldable Sunshade',
      category_image:
        'https://images.myloapp.in/NestJsUploads/1690866572314-Foldable-Sunshade.webp',
    },
    {
      category_name: 'Bottle Holder',
      category_image:
        'https://images.myloapp.in/NestJsUploads/1694091717219-features-section_bottle-holder.webp',
    },
    {
      category_name: 'Generous Storage',
      category_image:
        'https://images.myloapp.in/NestJsUploads/1690866572315-GenerousStorage.webp',
    },
    {
      category_name: 'Peek-a-boo Mesh Window',
      category_image:
        'https://images.myloapp.in/NestJsUploads/1690866572315-Peek-a-boo-Mesh-Window.webp',
    },
    {
      category_name: 'Swivel Wheels With Lock',
      category_image:
        'https://images.myloapp.in/NestJsUploads/1694091828403-features-section_swivel-wheels-(1).webp',
    },
  ],
  banner_image:
    'https://images.myloapp.in/NestJsUploads/1695128000468-Stroller-Listing-3.mp4',
  banner_type: 'VIDEO',
  showBuyNow: false,
  showParition: false,
};

export const parentsAprrove = {
  heading: 'Babies Enjoy, Parents Approve',
  gifs: [
    {
      image:
        'https://images.myloapp.in/NestJsUploads/1692276215113-1691151016846-Stoller-Walking-3X4-.mp4',
      ar: '0.75',
      type: 'video',
    },
    {
      image:
        'https://images.myloapp.in/NestJsUploads/1691492262350-1x1-updated-img.webp',
      ar: '1',
      type: 'image',
    },
    {
      image:
        'https://images.myloapp.in/NestJsUploads/1692276215121-1691492262344-Stoller-Canopy-3X4.mp4',
      ar: '1',
      type: 'video',
    },

    {
      image:
        'https://images.myloapp.in/NestJsUploads/1691380231483-3x4-img.webp',
      ar: '0.75',
      type: 'image',
    },
    {
      image:
        'https://images.myloapp.in/NestJsUploads/1691380231479-1x1-img.webp',
      ar: '1',
      type: 'image',
    },

    {
      image:
        'https://images.myloapp.in/NestJsUploads/1692276215120-1691380330013-Stoller-Folding-3X4.mp4',
      ar: '0.75',
      type: 'video',
    },
  ],
  // banner_image: "https://images.myloapp.in/general_tab/168568878999.webp",
  // banner_type: "IMAGE",
  showBuyNow: false,
};
const blue_carousel_images = [
  {
    image:
      'https://images.myloapp.in/NestJsUploads/1695202586679-blue-stroller-first-listing-image.webp',
  },
  {
    image:
      'https://images.myloapp.in/NestJsUploads/1694084482638-2_blue_front-view.webp',
  },
  {
    image:
      'https://images.myloapp.in/NestJsUploads/1694084507303-3_blue_back-view.webp',
  },
  {
    image:
      'https://images.myloapp.in/NestJsUploads/1694084568760-4_blue_zoomed-side-view.webp',
  },
  {
    image:
      'https://images.myloapp.in/NestJsUploads/1694084620960-5_blue_five-point-safety.webp',
  },
  {
    image:
      'https://images.myloapp.in/NestJsUploads/1694084642132-6_blue_bottle-holder.webp',
  },
  {
    image:
      'https://images.myloapp.in/NestJsUploads/1694084666888-7_blue_button.webp',
  },
];

const grey_carousel_images = [
  {
    image:
      'https://images.myloapp.in/NestJsUploads/1695128525463-grey-stroller-first-listing-image.webp',
  },
  {
    image:
      'https://images.myloapp.in/NestJsUploads/1694081410404-2_grey_front-view.webp',
  },
  {
    image:
      'https://images.myloapp.in/NestJsUploads/1694081453737-3_grey_back-view.webp',
  },
  {
    image:
      'https://images.myloapp.in/NestJsUploads/1694081478544-4_grey_zoomed-side-view.webp',
  },
  {
    image:
      'https://images.myloapp.in/NestJsUploads/1694081502003-5_grey_five-point-safety.webp',
  },
  {
    image:
      'https://images.myloapp.in/NestJsUploads/1694081527740-6_grey_bottle-holder.webp',
  },
  {
    image:
      'https://images.myloapp.in/NestJsUploads/1694081598838-7_grey_button.webp',
  },
];

export const faqsDataStrollerBlack = {
  hideMargin: true,
  faqs: [
    {
      questionName: 'SPECIFICATIONS',
      acceptedAnswerText: {
        list: [
          'Color- Charcoal Grey',
          'Age Group - 0 - 36 Months',
          'Carrying Capacity: 15 Kgs',
          'Certified as per European Safety Standard EN 1888.',
        ],
      },
    },
    {
      questionName: 'FAQS',
      acceptedAnswerText: {
        questions: [
          {
            question: 'Q-: Is it OK if baby sleeps in stroller?',
            answer:
              'Ans-: Yes, it is safe for babies to take naps in a stroller. However, you must not let it become a habit and never leave your baby alone while they’re in the stroller.',
          },
          {
            question: 'Q-: Can a stroller be carried in flight?',
            answer:
              'Ans-: Yes, most airlines allow at least one stroller to be checked for free, with weight, size, and collapsibility restrictions. It is recommended to use a lightweight stroller that can be folded easily.',
          },
          {
            question: 'Q-: Is this baby stroller foldable?',
            answer:
              'Ans-: Yes, Mylo offers easy-to-fold and carry strollers that are so compact they can fit easily into cupboards, car trunks and even plane cabins.',
          },
          {
            question:
              'Q-: Will I need to buy a bigger stroller as my baby grows older?',
            answer:
              'Ans-: As your baby grows from a newborn to a toddler, your requirements for a stroller are likely to change. But if you’re looking for a one-time investment, then Mylo offers strollers that are suitable for newborns to 3-year-old babies.',
          },
        ],
      },
    },
  ],
};
export const faqsDataStrollerBlue = {
  hideMargin: true,
  faqs: [
    {
      questionName: 'SPECIFICATIONS',
      acceptedAnswerText: {
        list: [
          'Color- Powder Blue',
          'Age Group - 0 - 36 Months',
          'Carrying Capacity: 15 Kgs',
          'Certified as per European Safety Standard EN 1888.',
        ],
      },
    },
    {
      questionName: 'FAQS',
      acceptedAnswerText: {
        questions: [
          {
            question: 'Q-: Is it OK if baby sleeps in stroller?',
            answer:
              'Ans-: Yes, it is safe for babies to take naps in a stroller. However, you must not let it become a habit and never leave your baby alone while they’re in the stroller.',
          },
          {
            question: 'Q-: Can a stroller be carried in flight?',
            answer:
              'Ans-: Yes, most airlines allow at least one stroller to be checked for free, with weight, size, and collapsibility restrictions. It is recommended to use a lightweight stroller that can be folded easily.',
          },
          {
            question: 'Q-: Is this baby stroller foldable?',
            answer:
              'Ans-: Yes, Mylo offers easy-to-fold and carry strollers that are so compact they can fit easily into cupboards, car trunks and even plane cabins.',
          },
          {
            question:
              'Q-: Will I need to buy a bigger stroller as my baby grows older?',
            answer:
              'Ans-: As your baby grows from a newborn to a toddler, your requirements for a stroller are likely to change. But if you’re looking for a one-time investment, then Mylo offers strollers that are suitable for newborns to 3-year-old babies.',
          },
        ],
      },
    },
  ],
};
export const related_articles = {
  heading: 'From Our Blog',
  hideMargin: true,
  articles: [
    {
      content: {
        id: 12965,
        webpImages: [
          'https://images.myloapp.in/NestJsUploads/1694418624251-Stroller-Safety-101.webp',
        ],
        tagsWithId: [{ description: 'SAFETY & CARE' }],
        web_url:
          '/article/stroller-safety-101-tips-for-keeping-your-baby-safe-with-the-best-strollers-12965',
        title:
          'Stroller Safety 101: Tips For Keeping Your Baby Safe With The Best Strollers',
      },
    },
    {
      content: {
        id: 194808,
        title: 'How to Choose the Safest & Best Stroller for Your Baby?',
        webpImages: [
          'https://images.myloapp.in/NestJsUploads/1694424368213-How-to-Choose-the-Safest.webp',
        ],
        tagsWithId: [{ description: 'BABY CARE' }],
        web_url:
          '/article/how-to-choose-the-safest-best-stroller-for-your-baby-194808 ',
      },
    },
  ],
};

export const makeYourMove = {
  heading: 'Make It Yours',
  subPoints: [
    {
      description:
        'Embrace travel-friendly convenience without compromising on safety or style. ',
    },
    {
      description:
        'Introducing the Mylo Baby Premium Stroller - where each journey becomes an unforgettable adventure.',
    },
  ],
  productDetails: {
    image:
      'https://images.myloapp.in/NestJsUploads/1690872173706-2631_stroller.webp',
    strikePrice: '₹8599',
    price: '₹5999',
    discountPercentage: '31% OFF',
    showCta: true,
    bottomCta: 'MRP incl. of taxes',
  },
  // banner_image: "https://images.myloapp.in/general_tab/168568878999.webp",
  // banner_type: "IMAGE",
  showBuyNow: false,
  hideDesktop: true,
};
export const makeYourMoveGrey = {
  heading: 'Make It Yours',
  subPoints: [
    {
      description:
        'Embrace travel-friendly convenience without compromising on safety or style. ',
    },
    {
      description:
        'Introducing the Mylo Baby Premium Stroller - where each journey becomes an unforgettable adventure.',
    },
  ],
  productDetails: {
    image:
      'https://images.myloapp.in/NestJsUploads/1690872173704-2632_stroller.webp',
    strikePrice: '₹8599',
    price: '₹5999',
    discountPercentage: '31% OFF',
    showCta: true,
    bottomCta: 'MRP incl. of taxes',
  },
  // banner_image: "https://images.myloapp.in/general_tab/168568878999.webp",
  // banner_type: "IMAGE",
  showBuyNow: false,
  hideDesktop: true,
};
export const chooseYourColor = {
  heading: 'Choose your color',
  subPoints: [
    {
      description:
        'Embrace travel-friendly convenience without compromising on safety or style. ',
    },
  ],
  productVarients: [
    {
      image:
        'https://images.myloapp.in/NestJsUploads/1694371992600-blue_make-it-yours-section.webp',
      name: 'Powder Blue',
      cta: 'BUY',
      id: 2631,
    },
    {
      image:
        'https://images.myloapp.in/NestJsUploads/1694372196803-grey_make-it-yours-section.webp',
      name: 'Charcoal Grey',
      cta: 'BUY',
      id: 2632,
    },
  ],
  // banner_image: "https://images.myloapp.in/general_tab/168568878999.webp",
  // banner_type: "IMAGE",
  hideDesktop: true,
};

export const strollerAllData = {
  2631: {
    carousel_images: blue_carousel_images,
    tag_name: 'MYLO BABY',
    name: 'Mylo Baby Premium Stroller : Light-Weight • One Touch Fold • EN-1888 Certified Safe',
    price: 5999,
    strikePrice: 8599,
    discount: '31% OFF',
    bottomText: 'MRP incl. of taxes',
    id: 2631,
    varients: [
      { name: 'Powder Blue', color: '#548AC4', id: 2631 },
      { name: 'Charcoal Grey', color: '#626262', id: 2632 },
    ],
    generalItemsData: [
      oneTouchFold,
      superiorSafety,
      readyForAdventure,
      parentsAprrove,
      chooseYourColor,
      faqsDataStrollerBlue,
      related_articles,
    ],
  },
  2632: {
    carousel_images: grey_carousel_images,
    tag_name: 'MYLO BABY',
    name: 'Mylo Baby Premium Stroller : Light-Weight • One Touch Fold • EN-1888 Certified Safe',
    price: 5999,
    strikePrice: 8599,
    discount: '31% OFF',
    bottomText: 'MRP incl. of taxes',
    id: 2632,
    varients: [
      { name: 'Powder Blue', color: '#548AC4', id: 2631 },
      { name: 'Charcoal Grey', color: '#626262', id: 2632 },
    ],
    generalItemsData: [
      oneTouchFold,
      superiorSafety,
      readyForAdventureGrey,
      parentsAprrove,
      chooseYourColor,
      faqsDataStrollerBlack,
      related_articles,
    ],
  },
};

export const stroller_tags_data = [
  {
    name: 'Free Delivery PAN India',
    image:
      'https://images.myloapp.in/NestJsUploads/1690874882641-delivery.webp',
    tag: 'Nationwide doorstep facility absolutely free!',
    imgWidth: 70,
    imgHeight: 33,
  },
  {
    name: '15-Day Risk Free Trial',
    image:
      'https://images.myloapp.in/NestJsUploads/1694415544795-risk_free_trial_image.webp',
    tag: 'Your Satisfaction is our Priority. If you are not 100% happy. Return it for full refund',
    imgWidth: 43,
    imgHeight: 53,
  },
  {
    name: 'Customer Support',
    image: 'https://images.myloapp.in/NestJsUploads/1690874882638-support.webp',
    tag: 'Have a question? Call or message us on *Whatsapp',
    imgWidth: 43,
    imgHeight: 43,
    whatsapp: true,
    url: 'https://api.whatsapp.com/send?phone=918047190745&text=Hi,%20I%20am%20interested%20in%20Mylo%20Rivera%20Stroller%20and%20I%20request%20a%20call%20back%20to%20know%20more%20about%20this%20product',
  },
];

export const strollerOfferData = {
  offerTag: 'Limited time offer',

  offerName: 'Get Mylo Baby Wellness Kit worth ₹1499 for FREE',
  offerValid: 'Offer valid till stocks last',
  offerCode: 'BABYKIT',

  offerImg:
    'https://images.myloapp.in/NestJsUploads/1698397527869-stroller-freebie.webp',
  offerProducts:
    'Baby Lotion (200ml), Tummy Roll-On (40ml), Baby Hair Oil (100 ml), Baby Massage Oil (200ml), Diaper Rash Cream (50g)',
};

export const strollerSeoMetaData = {
  metaTitle:
    'Ultra-light, Compact & Premium Stroller for Babies & Toddlers | MyloFamily',
  metaDescription:
    'Our baby stroller offers a five-point safety harness, multi-position reclining, foldable canopy and compact design that you can easily fold and carry anywhere you go. Certified and tested, Mylo stroller is a dependable choice for your family.',
};
